<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      palymusic: false,
    };
  },
  methods: {},
};
</script>

<style lang="scss">
:root {
  --fm-color-primary: #2265d9;

  --fm-color-black: #000;
  --fm-color-white: #fff;
  --fm-color-gray-1: #f7f8fa;
  --fm-color-gray-2: #f2f3f5;
  --fm-color-gray-3: #ebedf0;
  --fm-color-gray-4: #dcdee0;
  --fm-color-gray-5: #c8c9cc;
  --fm-color-gray-6: #969799;
  --fm-color-gray-7: #646566;
  --fm-color-gray-8: #323233;
  --fm-color-blue: #1989fa;
  --fm-color-green: #07c160;
  --fm-color-purple: #8e69d3;


  --fm-success-color: #5ac725;
  --fm-warning-color: #f9ae3d;
  --fm-danger-color: #f56c6c;
  --fm-error-color: #f56c6c;

}

body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  /* 默认字体大小 */
  font-size: 16px;
  color: var(--fm-color-gray-8);
}

/* 当屏幕宽度小于600px时 */
@media (max-width: 600px) {
  body {
    font-size: 15px;
  }
}

/* 当屏幕宽度大于1200px时 */
@media (min-width: 1200px) {
  body {
    font-size: 18px;
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100% !important;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: normal;
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}

.bgImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  image-rendering: -webkit-optimize-contrast;
  position: absolute;
  padding: 0px;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
}

.fm-flex {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.fm-center {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
}

.fm-aligncenter {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
}

.fm-justifycenter {
  display: flex !important;
  flex-direction: column;
  justify-content: center !important;
}

@keyframes playframes {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue